import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import styles from './DashboardPage.module.scss';

const DashboardPage: React.FC = () => {
    const { user } = useAuth();

    return (
        <div className={styles.dashboard}>
            <h1>Dashboard</h1>
            <p className={styles.welcome}>Bienvenue, {user?.firstname} {user?.lastname} !</p>
            
            <div className={styles.cards}>
                <div className={styles.card}>
                    <h3>Mon profil</h3>
                    <p>Gérez vos informations personnelles</p>
                </div>
                <div className={styles.card}>
                    <h3>Mes tournois</h3>
                    <p>Consultez vos inscriptions aux tournois</p>
                </div>
                <div className={styles.card}>
                    <h3>Mon classement</h3>
                    <p>Suivez votre progression</p>
                </div>
            </div>
        </div>
    );
};

export default DashboardPage;
